export default __webpack_public_path__ + "static/media/xml.47323fd2.svg";